import oRequest from "@/libsV2/request";
import {Toast} from 'vant'

const URL = {
    DESIGN_INFO: "design/index/designer",  //设计师信息
    SEARCH_DATA: "design/index/searchdata", //项目列表筛选项
    PROJECT_LIST: "design/index/lists",  //项目列表
    PROJECT_DETAILS: "design/index/index", //项目详情
    PROJECT_LOG: "design/report/projectlog", //项目日志
    PROJECT_TEAM: "design/index/teamv2", //项目团队
    CONTRACT_DETAILS: "design/index/contract", //产品清单-合同详情
    PROCESS_LIST: "design/index/process", //施工验收-交付报告列表
    PROCESS_DETAILS: "design/index/processinfo", //施工验收详情-交付报告详情
    CONTRACT_INFO: "design/index/contractinfo", //施工验收详情-交付报告详情
    GET_PHONE: "design/index/getphone", //通过合同id查设计师手机号
    GET_TREE: "https://asset.ali-cache.com/2022/0513/aosmith/core/api/js/district_1.0.1.json",//省市联动JSON
    FEEDADD:'discuss/indexv2/feedadd',//设计师吐槽
    DISCUSS_SHARE: 'design/discuss/share',//分享设计师埋点
    AO_AUTH:'wechat/api/getaoquaninit',//艾欧圈鉴权
};
export const feedadd = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.FEEDADD, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });

};
export const aoAuth = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.AO_AUTH, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};

export const getDesignInfo = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.DESIGN_INFO, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};

export const getSearchData = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.SEARCH_DATA, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};

export const getProjectList = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.PROJECT_LIST, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};

export const getProjectDetails = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.PROJECT_DETAILS, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};

export const getProjectLog = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.PROJECT_LOG, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};

export const getProjectTeam = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.PROJECT_TEAM, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};

export const getContractDetails = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.CONTRACT_DETAILS, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};

export const getProcessList = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.PROCESS_LIST, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};

export const getProcessDetails = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.PROCESS_DETAILS, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};

export const getContractInfo = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.CONTRACT_INFO, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};

export const getDesignerPhone = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.GET_PHONE, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};


export const getTree = () => {
    return new Promise((resolve, recject) => {
        oRequest.getDataJson(URL.GET_TREE).then(res => {
            resolve(res);
        }).catch((err) => {
            recject(err)
        })
    })
}


export const discussShare = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.DISCUSS_SHARE, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    })
}

